export default "__VITE_PUBLIC_ASSET__8a1686a0__"